const trimTrailingSlash = (value) => String(value || '').replace(/\/+$/, '');

const PLATFORM_DOMAIN_MARKERS = [
  'railway.app',
  'preview.emergentagent.com',
  'emergentagent.com',
];

const shouldPreferSameOrigin = (envHost, currentHost) => {
  if (!envHost || !currentHost || envHost === currentHost) {
    return false;
  }

  const envLooksPlatformManaged = PLATFORM_DOMAIN_MARKERS.some((marker) => envHost.includes(marker));
  const currentLooksPlatformManaged = PLATFORM_DOMAIN_MARKERS.some((marker) => currentHost.includes(marker));

  return envLooksPlatformManaged || currentLooksPlatformManaged;
};

export const getApiBaseUrl = () => {
  const envUrl = trimTrailingSlash(process.env.REACT_APP_BACKEND_URL);

  if (typeof window === 'undefined') {
    return envUrl;
  }

  const currentOrigin = trimTrailingSlash(window.location.origin);
  if (!envUrl) {
    return currentOrigin;
  }

  try {
    const envHost = new URL(envUrl).host;
    const currentHost = window.location.host;

    if (shouldPreferSameOrigin(envHost, currentHost)) {
      return currentOrigin;
    }
  } catch (error) {
    return currentOrigin;
  }

  return envUrl;
};
